<template src="./template.html"></template>

<script>
import qs from "qs"
export default {
  name: 'CheckOutShopCart',
  props: {
    shipfee: {
      require: true,
      type: Number
    },
    installment_fee: {
      require: true,
      type: Object
    },
    user_payway: {
      require: true,
      type: Object
    }
  },
  data() {
    return {
      show_shopcart_list: false,
      shopcart: null
    }
  },
  methods: {
    async ChangeAmount(item_index, amount) {
      if (parseInt(amount) <= 0 || isNaN(parseInt(amount)) || parseInt(amount) == '') {
        this.UpdateShopcartAmount()
      }
      else {
        await this.ChangeCartAmount(item_index, amount)
        this.CheckShopCart()
      }
    },
    async DeleteItem(index) {
      await this.DeleteFromCart(index)
      if (this.store_shopcart.length > 0) {
        this.CheckShopCart()
      }
    },
    UpdateShopcartAmount() {
      this.shopcart.forEach((item, item_index) => {
        item.amount = this.$store.state.shopcart[item_index].product_amount
        item.product_amount = this.$store.state.shopcart[item_index].product_amount
      })
    },
    async CheckShopCart() {
      let result = await this.SendPostData(process.env.VUE_APP_BASE_API + 'products/get_shopcart.php', qs.stringify({ shopcart: this.store_shopcart }))
      if (result != "error") {
        result.status == "warning" ? this.$store.commit("SetDialog", { title: "購物車內容已調整", content: result.msg, status: true }) : ""
        this.SetShopCart(JSON.parse(result.data))
        this.shopcart = JSON.parse(result.data)
      }
    },
    async CheckOrder() {
      let result = await this.SendPostData(process.env.VUE_APP_BASE_API + 'products/get_shopcart.php', qs.stringify({ shopcart: this.store_shopcart }))
      if (result != "error") {
        this.SetShopCart(JSON.parse(result.data))
        this.shopcart = JSON.parse(result.data)
        result.status == "warning" ? this.$store.commit("SetDialog", { title: "購物車內容已調整", content: result.msg, status: true }) : result.status == "success" ? this.$emit("send-order", this.total_price) : ""
      }
    }
  },
  async mounted() {
    await this.CheckShopCart()
    this.GA_BeginCheckout(this.shopcart)
  },
  computed: {
    store_shopcart() {
      return this.$store.state.shopcart
    },
    total_price() {
      if (this.shopcart != null) {
        let total_price = 0;
        this.shopcart.forEach(item => {
          total_price += parseInt(item.price) * parseInt(item.amount)
        });
        return total_price
      }
      else {
        return 0
      }
    },
    installment_fee_price() {
      if (this.user_payway.type == "zero_card") {
        return Math.ceil(this.installment_fee[this.user_payway.installment] * this.total_price)
      }
      else {
        return 0
      }
    }
  },
  watch: {
    shopcart() {
      if (this.shopcart.length <= 0) {
        this.$router.push('/')
      }
    },
    total_price() {
      this.$emit("set-price", this.total_price)
    }
  },
  filters: {
    priceFormat: function (val) {
      return val
        .toString()
        .replace(/^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/, function (
          all,
          pre,
          groupOf3Digital
        ) {
          return pre + groupOf3Digital.replace(/\d{3}/g, ',$&')
        })
    },
  },
}
</script>
